import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Harvesting extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Harvesting
        </h2>
        <h3>When to harvest</h3>
        <p>
        Determining when to harvest is very important, as harvesting too early decreases your yield and harvesting too late can alter the potency and effects of your strain. When bud stays on the plant too long you risk decreasing the mindfulness of your bud, and increasing body related effects, commonly known as couch lock.
        </p>
        <p>
        Most strains require 6 - 8 weeks of flowering on average, but can take as long as 10 - 12 weeks depending on the strain. If you purchased your seeds online, they usually list an estimated flowering time in days or week. Write down this estimate and circle it on your calendar. 
        </p>
        <h3>Pistils</h3>
        <p>
        You must also look at the plant itself to determine when to harvest. First evaluate the pistils or hairs on your bud. If they are primarily white and straight, the plant is not ready. Wait until you see more than half of the hairs darken, turn orange and curl. Harvesting when 60 - 70% of the hairs have darkened will yield the most THC while harvesting when 70 - 90% have darkened yields a more calming anti-anxiety effect. This is caused by THC morphing into CBN.
        </p>
        <h3>Trichromes</h3>
        <p>
        Next you’ll want look at the trichomes. They are the tiny crystals attached to the hairs on your bud. You’ll probably need a magnifying glass to properly view and evaluate them. When all of your trichomes are milky looking you’ll know it’s time to harvest. 
        </p>

        <h3>
        How to harvest
        </h3>
        <p>
        If you’ve reached this stage, congratulations you have successfully grown marijuana. Now it’s time harvest and prepare the weed for use. Before harvest you’ll want to do a little trimming. Cut any remaining large sun leafs off your plant, but leave any small leaves that are close to your bud. This leaves will protect your plant during drying and help preserve flavor. Next cut branches off your plant. You’ll want to leave your plant in large sections that are easy to hang for drying. 
        </p>
        <GuideButton slugTo="drying" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_harvesting.js